module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 form-group",
    class: {
      'has-error': this.validation && this.validation.$error
    }
  }, [_c('div', {
    staticClass: "input-group username-input has-feedback"
  }, [_c('float-label', {
    attrs: {
      "label": _vm.required ? _vm.label + '*' : _vm.label,
      "for": _vm.name,
      "fixed": _vm.type === 'date'
    }
  }, [(_vm.type === 'date') ? _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "date",
      "pattern": "\\d{4}-\\d{2}-\\d{2}",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label,
      "min": _vm.minDate,
      "max": _vm.maxDate,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  }) : _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon",
    class: _vm.displayIcons(_vm.name)
  })])], 1), _vm._v(" "), (_vm.validation && _vm.validation.$error) ? _c('div', {
    staticClass: "help-block small",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.requiredError) ? _c('span', [_vm._v("The field is required")]) : (!_vm.validation.maxLength && _vm.validation.$params.maxLength) ? _c('span', [_vm._v("\n          Maximum length is " + _vm._s(_vm.validation.$params.maxLength.max) + "\n        ")]) : (!_vm.validation.minLength && _vm.validation.$params.minLength) ? _c('span', [_vm._v("\n          Minimum length is " + _vm._s(_vm.validation.$params.minLength.min) + "\n        ")]) : (_vm.validation.dateFormat === false) ? _c('span', [_vm._v("The date field must be in a valid format")]) : (!_vm.validation.dateBetween && _vm.validation.$params.dateBetween) ? _c('span', [_vm._v("\n            Date must be between " + _vm._s(_vm.validation.$params.dateBetween.min) + " and\n          " + _vm._s(_vm.validation.$params.dateBetween.max) + "\n        ")]) : (_vm.validation.$invalid) ? _c('span', [_vm._v("The " + _vm._s(_vm.label.toLowerCase()) + " field is invalid.")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-200cbaef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputs/InputText.vue
// module id = 652
// module chunks = 5